import { render, staticRenderFns } from "./CustomCheckboxMultiple.vue?vue&type=template&id=68164cf2&"
import script from "./CustomCheckboxMultiple.vue?vue&type=script&lang=js&"
export * from "./CustomCheckboxMultiple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports